module.exports = __webpack_public_path__ + "img/defaultMark01.09476959.png";